<template>
  <div class="body-bg">
    <div class="component-area">
      <study-page v-if="currentPage == 1"></study-page>
      <book-page v-else-if="currentPage == 2"  @jump-study="jumpToStudy"></book-page>
      <word-book-page v-else-if="currentPage == 3"></word-book-page>
      <rank-list-page v-else-if="currentPage == 4"></rank-list-page>
      <reccord-page v-else-if="currentPage == 5"></reccord-page>
      <train-page v-else-if="currentPage == 6"></train-page>
    </div>
  </div>
</template>

<script>
import StudyPage from "./study";
import BookPage from "./book";
import WordBookPage from "./word-book";
import RankListPage from "./rank-list";
import RecordPage from "./reccord";
import TrainPage from "./train";

export default {
  components: {
    'study-page': StudyPage,
    'book-page': BookPage,
    'word-book-page': WordBookPage,
    'rank-list-page': RankListPage,
    'reccord-page': RecordPage,
    'train-page': TrainPage,
  },
  props: ['currentPage'],
  data() {
    return {
    }
  },
  methods: {
    jumpToStudy() {
      this.$emit('click-page',1)
    }
  }
}
</script>

<style scoped>
.body-bg{
  width: 100%;
}
.component-area{
  padding: 0px 0 0 0;
}
</style>
